import { render, staticRenderFns } from "./databasePatrol.vue?vue&type=template&id=55f36fb1"
import script from "./databasePatrol.vue?vue&type=script&lang=js"
export * from "./databasePatrol.vue?vue&type=script&lang=js"
import style0 from "./databasePatrol.vue?vue&type=style&index=0&id=55f36fb1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports